import { createSlice } from "@reduxjs/toolkit";
import { getDriverProfile } from "../../apis/setting/getDriverProfile";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const getDriverProfileSlice = createSlice({
    name: 'getDriverProfile',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(getDriverProfile.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(getDriverProfile.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(getDriverProfile.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default getDriverProfileSlice.reducer